import { __assign as t } from "./_virtual/_tslib.js";
import { forwardRef as o, useMemo as e, useImperativeHandle as n, useEffect as s } from "react";
import { useEvent as i } from "./hooks/events.js";
import { nearPair as r } from "./utils/compare.js";
import m from "./utils/clone.js";
import { useBindProp as p } from "./hooks/props.js";
import { lngLat2Array as c } from "./utils/convert.js";
import { getInitialOptionsFromProps as f } from "./utils/options.js";
import u from "./useAmap.js";
import l from "./hooks/component.js";
import { Anchors as a } from "./utils/types.js";
import { createPortal as v } from "react-dom";
var d = o(function (o, d) {
  var j = u(),
      g = o.visible,
      h = void 0 === g || g,
      w = e(function () {
    return document.createElement("div");
  }, []),
      y = l({
    init: function init(e) {
      var n = t(t({}, f(o, !0, [], ["className", "style"])), {
        position: m(o.position)
      });
      return new e.InfoWindow(n);
    },
    add: function add(t, o) {
      if (o.setMap(t), h) {
        var e = c(o.getPosition());
        o.open(t, e);
      }
    }
  }, o);
  return n(d, function () {
    return y;
  }, [y]), s(function () {
    w.className = o.className || "";
  }, [o.className]), s(function () {
    w.style.cssText = "", Object.assign(w.style, o.style);
  }, [o.style]), p(y, {
    setter: function setter(t, o) {
      t.setSize(new AMap.Size(o[0], o[1]));
    }
  }, o.size), p(y, {
    setter: "setAnchor",
    validate: function validate(t) {
      return a.includes(t);
    }
  }, o.anchor), p(y, {
    setter: function setter(t, o) {
      t.setOffset(new window.AMap.Pixel(o[0], o[1]));
    }
  }, o.offset), p(y, {
    getter: function getter(t) {
      return c(t.getPosition());
    },
    equals: r,
    setter: function setter(t, o) {
      t.getIsOpen() ? t.open(t.getMap(), o) : t.setPosition(o);
    }
  }, o.position), p(y, {
    setter: function setter(t, e) {
      o.isCustom || t.setContent(e);
    }
  }, o.content), p(y, {
    setter: function setter(t, o) {
      if (j) if (o) {
        var e = c(t.getPosition());
        t.open(j, e);
      } else t.close();
    }
  }, o.visible), i(y, "open", o.onOpen), i(y, "close", o.onClose), o.isCustom ? (y && (y.setContent(w), h && y.open(y.getMap(), o.position)), v(o.children, w)) : null;
});
export default d;